import { Component, Input, ViewChild, Directive, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from '../services/data.service';
import * as _ from 'lodash';
import * as numberFormatting from '../../libs/jsCalc/numberFormatting';
import * as Highcharts from 'highcharts';
import * as HighchartsMore from 'highcharts/highcharts-more';
// import * as HighchartsExporting from 'highcharts/modules/exporting.js'
// import * as HighchartsOfflineExporting from 'highcharts/modules/offline-exporting.js'
import { ChartDefaults } from './chartdefaults';

const RE_RENDER_COLUMN_GRAPH = "rerender-column-graph";

@Component({
    selector: 'column',
    template: require('./column.html')
})

export class ColumnComponent implements OnDestroy, OnInit {
    @Input() data:any;
    @Input() categorylabels:Array<any>;
    @Input() serieslabels:Array<any>;
    @Input() legendlabels:Array<any>;
    @Input() year:string = "";
    @Input() chartoptions:any = "";
    @Input() min:number;
    @Input() max:number;
    @Input() yAxisTickInterval:number;
    @Input() numberformat:string = "";
    @Input() charttitle:string = "";
    @Input() width:number;
    @Input() height:number;
    @Input() linewidth = "";
    @Input() charttitleoffsety:number = -35;
    @Input() chartmargintop:number = 0;
    @Input() legendalign = "center";
    @Input() legendverticalalign = "bottom";
    @Input() legendlayout = "horizontal";
    @Input() dataFormat: string;
    @Input() columnType:any;

    private chart:any = null;
    private observer:any;
    private gaugeVal:number = 0;
    private $elementRef:any = ElementRef;
    private el:ElementRef = null;
    private localDataArray = [];
    private localCategoryLabelsArray = [];
    private localSeriesLabelsArray = [];

    private chartData: any;

    constructor(el: ElementRef, private chartDefaults: ChartDefaults, public dataService: DataService) {
        let self = this;
        self.el = el;
        // extend highcharts with highcharts-more
        HighchartsMore(Highcharts);
        //HighchartsExporting(Highcharts);
        //HighchartsOfflineExporting(Highcharts);
    }

    ngOnDestroy() {
        if (this.chart) {
            this.chart.destroy();
        }
    }

    ngOnInit() {
        if (!this.chart) {
            this.renderGraph();
        }
        
        this.dataService.getObservable(RE_RENDER_COLUMN_GRAPH).subscribe((result) => {
            this.reRenderGraph(result[0]);
        });
        //this.processChartInputs();
    }

    renderGraph() {
        var opt = {}, self = this;
        var appendFormat;
        
        if (this.dataFormat === 'percent') {
            appendFormat = '%';
        }

        this.chartData = this.chartDefaults.getBasicColumnChartDefaults(null, appendFormat);

        //self.chartData.chart.width = "900";
        //self.chartData.chart.height = "500";

        self.chartData.chart.renderTo = self.el.nativeElement.childNodes[0];

        if (this.legendlabels === undefined || this.legendlabels.length === 0) {
            this.legendlabels = this.serieslabels;
        }
        if (this.min != undefined) {
            self.chartData.yAxis.min = this.min;
        }
        if (this.max != undefined) {
            self.chartData.yAxis.max = this.max;
        }
        if (this.yAxisTickInterval != undefined) {
            self.chartData.yAxis.tickInterval = this.yAxisTickInterval;
        }
        self.chartData.legend.align = this.legendalign;
        self.chartData.legend.verticalAlign = this.legendverticalalign;
        self.chartData.legend.layout = this.legendlayout;

        if (this.columnType === "multiattempt") {
            self.chartData.xAxis.labels.enabled = false;
        } else {
            self.chartData.xAxis.labels.enabled = true;
        }
        
        if (this.charttitle != "" && this.charttitle != undefined) {
            self.chartData.title.text = this.charttitle;
            self.chartData.title.style = {
                fontFamily: "'OpenSans', Helvetica, Arial, sans-serif"
            }
        }
 
        for (let i = 0; i < self.categorylabels.length; i++) {
            if (self.categorylabels[i]) {
                self.chartData.xAxis.categories[i] = self.categorylabels[i];
            }
            else {
                self.chartData.xAxis.categories[i] = '';
            }
        }
     

        let sum = 0;
        if (this.dataFormat === 'percent') {
            for (let i = 0; i < self.serieslabels.length; i++) {
                let seriesName = self.serieslabels[i];
                for (let j = 0; j < self.data[seriesName].length; j++) {
                    sum += self.data[seriesName][j];
                }
            }
        }
        
        for (let i = 0; i < self.serieslabels.length; i++) {
            let localDataArray = [];
            let seriesName = self.serieslabels[i];
            let legendName = self.legendlabels[i];
            
            for (let j = 0; j < self.data[seriesName].length; j++) {
                if (this.dataFormat === 'percent') {
                    localDataArray.push((Number(self.data[seriesName][j]) / sum) * 100);
                }
                else {
                    localDataArray.push(Number(self.data[seriesName][j]));
                }
            }

            self.chartData.series.push ({
                name: legendName,
                data: localDataArray,
                lineWidth: 1
            });
        }

        if (self.chartoptions !== "")
            self.chartoptions = JSON.parse(self.chartoptions);

        _.merge(opt, self.chartData, self.chartoptions);

        self.chart = new Highcharts.Chart(opt);
    }

    reRenderGraph(chartData: any) {
        this.data = chartData.data;
        this.serieslabels = chartData.serieslabels;
        this.legendlabels = chartData.legendlabels;
        this.categorylabels = chartData.categorylabels;
        this.chartoptions = chartData.chartoptions;
        this.min = chartData.min;
        this.max = chartData.max;
        this.renderGraph();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/charts/column.ts